{
    "coordinates": [
        50.056930666422716,
        7.436062626984949
    ],
    "tooltip": "Hunsrück Slate",
    "title": "Hunsrück Slate",
    "country": "Germany",
    "period": "Devonian",
    "alt": "TODO"
}
